export const IcWarning = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
		<line x1="12" y1="9" x2="12" y2="13" />
		<line x1="12" y1="17" x2="12.01" y2="17" />
	</svg>
);

export const IcBox = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
		<polyline points="3.3 7 12 12 20.7 7" />
		<line x1="12" y1="22" x2="12" y2="12" />
	</svg>
);

export const IcCalendar = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<rect x="3" y="4" width="18" height="18" rx="2" />
		<line x1="16" y1="2" x2="16" y2="6" />
		<line x1="8" y1="2" x2="8" y2="6" />
		<line x1="3" y1="10" x2="21" y2="10" />
	</svg>
);

export const IcChevR = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<polyline points="9 6 15 12 9 18" />
	</svg>
);

export const IcSearch = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<circle cx="11" cy="11" r="7" />
		<line x1="21" y1="21" x2="16.65" y2="16.65" />
	</svg>
);

export const IcTarget = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<circle cx="12" cy="12" r="9" />
		<circle cx="12" cy="12" r="5" />
		<circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
	</svg>
);

export const IcBolt = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
	</svg>
);

export const IcFlame = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="1.8"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<path d="M8.5 14.5A2.5 2.5 0 0 0 11 17c1.4 0 2-1 2-2 0-1-.6-2-2-2-1 0-1.5.5-1.5 1zM12 2c0 4-3 5-3 9a5 5 0 0 0 10 0c0-2-1-3-2-4 0-1 0-2-1-3-1.5-1.5-3-2-4-2z" />
	</svg>
);

export const SparkMark = ({ size = 20 }: { size?: number }) => (
	<span
		className='chatBot--spark-mark'
		style={{ width: size, height: size, borderRadius: Math.round(size * 0.3) }}>
		<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
			style={{ width: '58%', height: '58%' }}>
			<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
			<path d="M19 3l.6 1.8L21 5.4l-1.4.6L19 7.8l-.6-1.8L17 5.4l1.4-.6z" />
		</svg>
	</span>
);

export const IcInvoice = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<polyline points="14 2 14 8 20 8" />
		<line x1="8" y1="13" x2="16" y2="13" />
		<line x1="8" y1="17" x2="14" y2="17" />
	</svg>
);

export const SparkSvg = ({ size = 12 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
		style={{ width: size, height: size, flexShrink: 0 }}>
		<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
		<path d="M19 3l.6 1.8L21 5.4l-1.4.6L19 7.8l-.6-1.8L17 5.4l1.4-.6z" />
	</svg>
);

export const IcInfo = ({ size = 14 }: { size?: number }) => (
	<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
		style={{ width: size, height: size, flexShrink: 0, fill: 'none' }}>
		<circle cx="12" cy="12" r="10" />
		<line x1="12" y1="16" x2="12" y2="12" />
		<line x1="12" y1="8" x2="12.01" y2="8" />
	</svg>
);
